export const formatDateToShortWithLocale = (_date: Date | string | number, locale = 'en-US') => {
    if (!_date) return '';
    const date = new Date(_date);
    const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: 'numeric',
        year: '2-digit',
    };
    return new Intl.DateTimeFormat(locale, options).format(date);
};
